import { defineStore } from 'pinia'
import { getLayaToken, getAssetStoreToken, setLayaToken, setAssetStoreToken, setAssetStoreUser, getAssetStoreUser, removeToken } from '@/utils/auth'
import { login } from '@/api/user';
import { getUrlParms, routerMode } from '@/utils/index';
import { useRouter } from 'vue-router'
// import { tokenWhite } from '@/utils';
// const router = useRouter()
// console.log(router)

export const useUserStore = defineStore('user', {
  state: () => ({
    token: '',
    userInfo: null,
    isInitSdk: false,
    isLogin: false
  }),

  actions: {
    async login() {
      const _this = this
      return new Promise(async (resolve, reject) => {
        console.log("LAYA_UNIFY_SDK", window.LAYA_UNIFY_SDK);

        if (!_this.isInitSdk) {
          await _this.initSdk()
        }
        debugger
        let index = window.location.href.indexOf("?")
        let loginUrl = index == -1 ? window.location.href : window.location.href.substring(0, index)
        LAYA_UNIFY_SDK.login({ "loginUrl":  loginUrl}, function (data) {
          console.log("laya login callback", data)
          // if (router && data.result == -1 && tokenWhite.indexOf(router.currentRoute.value.path) != -1) {
          //   router.push({ path: "/"})
          // }
          if (data.result != 0) {
            resolve(false)
            return false
          }
          setLayaToken(data.token)
          login({
            code: data.token,
            game_id: "laya_0012",
            sp_id: 432,
            login_sp: 432
          }).then( response => {
            const { data } = response.data
            if (!data) {
              reject('验证失败，请重新登录。')
            }

            setAssetStoreToken(data.token)
            setAssetStoreUser(data)
            _this.token = data.token
            _this.userInfo = data
            _this.isLogin = true
            resolve(data)
            // if (window.location.href.indexOf("?") != -1) {
            //   setTimeout(() => {
            //     console.log(window.location.href.substring(0, window.location.href.indexOf("?")))
            //     debugger
            //     window.location.href = window.location.href.substring(0, window.location.href.indexOf("?"))
            //   }, 1)
            // }
          }).catch(error => {
            reject(error)
          })
        })
      })
    },

    async initSdk() {
      console.log("initSdk")
      const _this = this
      return new Promise((resolve) => {
        LAYA_UNIFY_SDK && LAYA_UNIFY_SDK.init({
          company: "huo5game", appId: "10001", loginChannel: ['passport', 'weChat'], payChannel: [], loginClose: true, loginByWeChat: true, gaeIframe: ""
        }, function () {
          _this.isInitSdk = true
          resolve()
        })
      })
    },

    checkLogin() {
      if (this.isLogin) {
        return true
      }
      let url = new URL(window.location.href)
      let urlToken = url.searchParams.get("token") || getUrlParms("token")
      console.log("urlToken", urlToken)
      if (urlToken) {
        let storeLayaToken = getLayaToken()
        if (storeLayaToken != urlToken) {
          this.isLogin = false
          return false
        }
      }

      let assetToken = getAssetStoreToken()
      if (!assetToken) {
        this.isLogin = false
        return false
      }
      this.token = assetToken
      let userInfo = getAssetStoreUser()
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo)
      }
      this.isLogin = true
      return true
    },

    async logout() {
      const _this = this
      return new Promise((resolve, reject) => {
        LAYA_UNIFY_SDK && LAYA_UNIFY_SDK.logout(() => {
          removeToken()
          _this.token = ''
          _this.userInfo = null
          _this.isLogin = false
          resolve()
        })
      })
    }
  }
})
